import React, { PropsWithChildren } from "react";
import styles from "./ProductTypeColor.module.scss";
import clsx from "clsx";

type Props = {
  productType: "ocean" | "expedition" | undefined;
} & React.HTMLAttributes<HTMLDivElement>;

export const ProductTypeColor: React.FC<PropsWithChildren<Props>> = ({
  productType,
  children,
  className,
  ...props
}) => {
  return (
    <div
      data-testid="container"
      className={clsx(
        {
          [styles.ocean]: productType === "ocean",
          [styles.expedition]: productType === "expedition"
        },
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
